const scatterplotdata = [
    {
        "id": "group A",
        "data": [
            {
                "x": 37,
                "y": 16
            },
            {
                "x": 53,
                "y": 64
            },
            {
                "x": 63,
                "y": 81
            },
            {
                "x": 95,
                "y": 74
            },
            {
                "x": 79,
                "y": 27
            },
            {
                "x": 76,
                "y": 21
            },
            {
                "x": 100,
                "y": 75
            },
            {
                "x": 76,
                "y": 116
            },
            {
                "x": 94,
                "y": 112
            },
            {
                "x": 18,
                "y": 84
            },
            {
                "x": 60,
                "y": 23
            },
            {
                "x": 91,
                "y": 48
            },
            {
                "x": 88,
                "y": 58
            },
            {
                "x": 10,
                "y": 54
            },
            {
                "x": 81,
                "y": 80
            },
            {
                "x": 64,
                "y": 1
            },
            {
                "x": 28,
                "y": 48
            },
            {
                "x": 51,
                "y": 35
            },
            {
                "x": 58,
                "y": 96
            },
            {
                "x": 65,
                "y": 56
            },
            {
                "x": 49,
                "y": 93
            },
            {
                "x": 48,
                "y": 13
            },
            {
                "x": 54,
                "y": 1
            },
            {
                "x": 98,
                "y": 35
            },
            {
                "x": 61,
                "y": 117
            },
            {
                "x": 23,
                "y": 25
            },
            {
                "x": 71,
                "y": 76
            },
            {
                "x": 82,
                "y": 16
            },
            {
                "x": 71,
                "y": 90
            },
            {
                "x": 27,
                "y": 111
            },
            {
                "x": 56,
                "y": 105
            },
            {
                "x": 93,
                "y": 93
            },
            {
                "x": 53,
                "y": 92
            },
            {
                "x": 98,
                "y": 68
            },
            {
                "x": 61,
                "y": 65
            },
            {
                "x": 27,
                "y": 68
            },
            {
                "x": 88,
                "y": 109
            },
            {
                "x": 25,
                "y": 30
            },
            {
                "x": 3,
                "y": 3
            },
            {
                "x": 21,
                "y": 10
            },
            {
                "x": 53,
                "y": 12
            },
            {
                "x": 49,
                "y": 37
            },
            {
                "x": 89,
                "y": 28
            },
            {
                "x": 57,
                "y": 0
            },
            {
                "x": 54,
                "y": 117
            },
            {
                "x": 39,
                "y": 7
            },
            {
                "x": 87,
                "y": 70
            },
            {
                "x": 1,
                "y": 26
            },
            {
                "x": 26,
                "y": 89
            },
            {
                "x": 11,
                "y": 109
            }
        ]
    },
    {
        "id": "group B",
        "data": [
            {
                "x": 19,
                "y": 94
            },
            {
                "x": 17,
                "y": 15
            },
            {
                "x": 96,
                "y": 20
            },
            {
                "x": 51,
                "y": 58
            },
            {
                "x": 62,
                "y": 58
            },
            {
                "x": 77,
                "y": 88
            },
            {
                "x": 50,
                "y": 12
            },
            {
                "x": 96,
                "y": 93
            },
            {
                "x": 100,
                "y": 1
            },
            {
                "x": 61,
                "y": 106
            },
            {
                "x": 8,
                "y": 103
            },
            {
                "x": 71,
                "y": 101
            },
            {
                "x": 41,
                "y": 114
            },
            {
                "x": 50,
                "y": 3
            },
            {
                "x": 7,
                "y": 97
            },
            {
                "x": 87,
                "y": 34
            },
            {
                "x": 48,
                "y": 69
            },
            {
                "x": 60,
                "y": 72
            },
            {
                "x": 73,
                "y": 57
            },
            {
                "x": 74,
                "y": 7
            },
            {
                "x": 26,
                "y": 97
            },
            {
                "x": 47,
                "y": 23
            },
            {
                "x": 92,
                "y": 120
            },
            {
                "x": 96,
                "y": 103
            },
            {
                "x": 59,
                "y": 119
            },
            {
                "x": 67,
                "y": 100
            },
            {
                "x": 9,
                "y": 64
            },
            {
                "x": 58,
                "y": 93
            },
            {
                "x": 53,
                "y": 100
            },
            {
                "x": 22,
                "y": 5
            },
            {
                "x": 1,
                "y": 30
            },
            {
                "x": 39,
                "y": 120
            },
            {
                "x": 83,
                "y": 14
            },
            {
                "x": 31,
                "y": 64
            },
            {
                "x": 9,
                "y": 114
            },
            {
                "x": 66,
                "y": 64
            },
            {
                "x": 59,
                "y": 87
            },
            {
                "x": 59,
                "y": 36
            },
            {
                "x": 79,
                "y": 82
            },
            {
                "x": 49,
                "y": 17
            },
            {
                "x": 16,
                "y": 34
            },
            {
                "x": 28,
                "y": 38
            },
            {
                "x": 98,
                "y": 82
            },
            {
                "x": 31,
                "y": 75
            },
            {
                "x": 79,
                "y": 118
            },
            {
                "x": 19,
                "y": 29
            },
            {
                "x": 34,
                "y": 45
            },
            {
                "x": 27,
                "y": 61
            },
            {
                "x": 82,
                "y": 3
            },
            {
                "x": 93,
                "y": 93
            }
        ]
    },
    {
        "id": "group C",
        "data": [
            {
                "x": 67,
                "y": 120
            },
            {
                "x": 97,
                "y": 65
            },
            {
                "x": 45,
                "y": 57
            },
            {
                "x": 28,
                "y": 39
            },
            {
                "x": 3,
                "y": 82
            },
            {
                "x": 44,
                "y": 66
            },
            {
                "x": 15,
                "y": 87
            },
            {
                "x": 74,
                "y": 76
            },
            {
                "x": 5,
                "y": 97
            },
            {
                "x": 28,
                "y": 48
            },
            {
                "x": 38,
                "y": 28
            },
            {
                "x": 1,
                "y": 115
            },
            {
                "x": 41,
                "y": 85
            },
            {
                "x": 26,
                "y": 75
            },
            {
                "x": 37,
                "y": 22
            },
            {
                "x": 29,
                "y": 8
            },
            {
                "x": 59,
                "y": 22
            },
            {
                "x": 14,
                "y": 87
            },
            {
                "x": 22,
                "y": 42
            },
            {
                "x": 81,
                "y": 12
            },
            {
                "x": 58,
                "y": 63
            },
            {
                "x": 73,
                "y": 116
            },
            {
                "x": 15,
                "y": 26
            },
            {
                "x": 75,
                "y": 8
            },
            {
                "x": 86,
                "y": 96
            },
            {
                "x": 49,
                "y": 29
            },
            {
                "x": 59,
                "y": 4
            },
            {
                "x": 76,
                "y": 114
            },
            {
                "x": 87,
                "y": 11
            },
            {
                "x": 98,
                "y": 119
            },
            {
                "x": 14,
                "y": 19
            },
            {
                "x": 23,
                "y": 108
            },
            {
                "x": 77,
                "y": 38
            },
            {
                "x": 33,
                "y": 19
            },
            {
                "x": 62,
                "y": 73
            },
            {
                "x": 1,
                "y": 50
            },
            {
                "x": 64,
                "y": 108
            },
            {
                "x": 7,
                "y": 68
            },
            {
                "x": 50,
                "y": 8
            },
            {
                "x": 4,
                "y": 26
            },
            {
                "x": 19,
                "y": 86
            },
            {
                "x": 66,
                "y": 99
            },
            {
                "x": 13,
                "y": 40
            },
            {
                "x": 64,
                "y": 60
            },
            {
                "x": 46,
                "y": 0
            },
            {
                "x": 62,
                "y": 69
            },
            {
                "x": 25,
                "y": 18
            },
            {
                "x": 98,
                "y": 8
            },
            {
                "x": 6,
                "y": 76
            },
            {
                "x": 25,
                "y": 56
            }
        ]
    },
    {
        "id": "group D",
        "data": [
            {
                "x": 18,
                "y": 91
            },
            {
                "x": 92,
                "y": 115
            },
            {
                "x": 97,
                "y": 93
            },
            {
                "x": 16,
                "y": 52
            },
            {
                "x": 7,
                "y": 2
            },
            {
                "x": 11,
                "y": 102
            },
            {
                "x": 87,
                "y": 72
            },
            {
                "x": 76,
                "y": 95
            },
            {
                "x": 8,
                "y": 64
            },
            {
                "x": 36,
                "y": 48
            },
            {
                "x": 61,
                "y": 116
            },
            {
                "x": 83,
                "y": 113
            },
            {
                "x": 82,
                "y": 21
            },
            {
                "x": 3,
                "y": 4
            },
            {
                "x": 14,
                "y": 70
            },
            {
                "x": 48,
                "y": 58
            },
            {
                "x": 98,
                "y": 86
            },
            {
                "x": 41,
                "y": 45
            },
            {
                "x": 62,
                "y": 38
            },
            {
                "x": 96,
                "y": 59
            },
            {
                "x": 31,
                "y": 33
            },
            {
                "x": 99,
                "y": 9
            },
            {
                "x": 42,
                "y": 19
            },
            {
                "x": 16,
                "y": 94
            },
            {
                "x": 26,
                "y": 106
            },
            {
                "x": 46,
                "y": 90
            },
            {
                "x": 91,
                "y": 63
            },
            {
                "x": 75,
                "y": 42
            },
            {
                "x": 96,
                "y": 8
            },
            {
                "x": 47,
                "y": 20
            },
            {
                "x": 48,
                "y": 24
            },
            {
                "x": 52,
                "y": 44
            },
            {
                "x": 11,
                "y": 34
            },
            {
                "x": 27,
                "y": 80
            },
            {
                "x": 61,
                "y": 39
            },
            {
                "x": 35,
                "y": 113
            },
            {
                "x": 32,
                "y": 65
            },
            {
                "x": 36,
                "y": 110
            },
            {
                "x": 51,
                "y": 13
            },
            {
                "x": 72,
                "y": 100
            },
            {
                "x": 4,
                "y": 38
            },
            {
                "x": 25,
                "y": 23
            },
            {
                "x": 36,
                "y": 59
            },
            {
                "x": 12,
                "y": 68
            },
            {
                "x": 55,
                "y": 18
            },
            {
                "x": 73,
                "y": 91
            },
            {
                "x": 50,
                "y": 9
            },
            {
                "x": 93,
                "y": 27
            },
            {
                "x": 33,
                "y": 72
            },
            {
                "x": 36,
                "y": 114
            }
        ]
    },
    {
        "id": "group E",
        "data": [
            {
                "x": 64,
                "y": 49
            },
            {
                "x": 9,
                "y": 46
            },
            {
                "x": 97,
                "y": 1
            },
            {
                "x": 24,
                "y": 42
            },
            {
                "x": 83,
                "y": 14
            },
            {
                "x": 24,
                "y": 93
            },
            {
                "x": 88,
                "y": 59
            },
            {
                "x": 24,
                "y": 21
            },
            {
                "x": 32,
                "y": 72
            },
            {
                "x": 3,
                "y": 27
            },
            {
                "x": 34,
                "y": 83
            },
            {
                "x": 36,
                "y": 77
            },
            {
                "x": 26,
                "y": 78
            },
            {
                "x": 15,
                "y": 43
            },
            {
                "x": 61,
                "y": 7
            },
            {
                "x": 64,
                "y": 56
            },
            {
                "x": 16,
                "y": 25
            },
            {
                "x": 11,
                "y": 109
            },
            {
                "x": 6,
                "y": 44
            },
            {
                "x": 33,
                "y": 71
            },
            {
                "x": 66,
                "y": 112
            },
            {
                "x": 53,
                "y": 112
            },
            {
                "x": 87,
                "y": 58
            },
            {
                "x": 61,
                "y": 35
            },
            {
                "x": 97,
                "y": 104
            },
            {
                "x": 48,
                "y": 104
            },
            {
                "x": 85,
                "y": 27
            },
            {
                "x": 99,
                "y": 62
            },
            {
                "x": 97,
                "y": 55
            },
            {
                "x": 52,
                "y": 85
            },
            {
                "x": 0,
                "y": 75
            },
            {
                "x": 65,
                "y": 6
            },
            {
                "x": 19,
                "y": 45
            },
            {
                "x": 7,
                "y": 111
            },
            {
                "x": 40,
                "y": 80
            },
            {
                "x": 88,
                "y": 48
            },
            {
                "x": 93,
                "y": 10
            },
            {
                "x": 20,
                "y": 26
            },
            {
                "x": 35,
                "y": 47
            },
            {
                "x": 37,
                "y": 70
            },
            {
                "x": 36,
                "y": 76
            },
            {
                "x": 63,
                "y": 5
            },
            {
                "x": 34,
                "y": 16
            },
            {
                "x": 3,
                "y": 3
            },
            {
                "x": 85,
                "y": 0
            },
            {
                "x": 39,
                "y": 31
            },
            {
                "x": 46,
                "y": 63
            },
            {
                "x": 42,
                "y": 45
            },
            {
                "x": 23,
                "y": 35
            },
            {
                "x": 86,
                "y": 72
            }
        ]
    }
]
export default scatterplotdata;